export enum ScrollDirection {
  DOWN = 'down',
  UP = 'up',
}

export interface ScrollState {
  direction: ScrollDirection;
  previousPosition: number;
}
